import { salesApi } from '../api/salesApi';

export const salesRepo = {
    getAll: (params) => salesApi.getAll(params),
    getMyShops: (params) => salesApi.getMyShops(params),
    getById: (salesId) => salesApi.getById(salesId),
    getByShop: (shopId, params) => salesApi.getByShop(shopId, params),
    getStatsByShop: (shopId, params) => salesApi.getStatsByShop(shopId, params),
    getBySeller: (sellerId) => salesApi.getBySeller(sellerId),
    getByStock: (stockId) => salesApi.getByStock(stockId),
    getByDateRange: (params) => salesApi.getByDateRange(params),
    getStats: () => salesApi.getStats(),
    export: (params) => salesApi.export(params),
    create: (data) => salesApi.create(data),
    update: (salesId, data) => salesApi.update(salesId, data),
    toggleStatus: (salesId) => salesApi.toggleStatus(salesId),
    bulkUpdateStatus: (data) => salesApi.bulkUpdateStatus(data),
};